import vLogo from './Logo.vue';

export { vLogo };



// WEBPACK FOOTER //
// ./src/appComponents/components/Logo/index.js